import { render, staticRenderFns } from "./ManageQuotaParking.vue?vue&type=template&id=607e4bb1&scoped=true"
import script from "./ManageQuotaParking.vue?vue&type=script&lang=js"
export * from "./ManageQuotaParking.vue?vue&type=script&lang=js"
import style0 from "./ManageQuotaParking.vue?vue&type=style&index=0&id=607e4bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e4bb1",
  null
  
)

export default component.exports